import SelectComponent from "ui-kit/src/SelectComponent/SelectComponent";
import { BooleanChoices } from "features/discover/types";
import { renderBoolean, renderBooleanChoiceLabel } from "../../cellRenderers";
import type { GameRow } from "../types";
import { discoverGameRowId } from "../rowHelpers";

/** Per-game VIP flag (`isVip` on PATCH) — inline Yes/No editing, gated by the GAME_VIP permission. */
export function DiscoverGamesIsVipDropdownCell({
	row,
	isUpdating = false,
	onChange,
	readOnlyTitle,
	canEditByPermission = false,
}: {
	row: GameRow;
	isUpdating?: boolean;
	onChange?: (gameId: number, isVip: boolean) => void;
	readOnlyTitle?: string;
	canEditByPermission?: boolean;
}) {
	const gameId = discoverGameRowId(row);
	const isVip = row.isVip === true;

	if (!onChange || gameId === null || !canEditByPermission) {
		return (
			<div className="thinCell" title={readOnlyTitle}>
				{renderBoolean(row.isVip)}
			</div>
		);
	}

	return (
		<div className="thinCell">
			<SelectComponent
				value={BooleanChoices.find((o) => o.value === (isVip ? "true" : "false")) ?? null}
				items={BooleanChoices}
				isCleareable={false}
				isDisabled={isUpdating}
				menuPortalTarget
				formatOptionLabel={renderBooleanChoiceLabel}
				handleChange={(option) => {
					if (option?.value === undefined) {
						return;
					}
					onChange(gameId, option.value === "true");
				}}
			/>
		</div>
	);
}
